var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RenderIf from 'syf-component-library/ui/atoms/RenderIf';
import { Routes } from '../../../const';
import { useMainContext } from '../../../context';
import useTranslation from '../../../hooks/use-translation';
import Stepper from './Stepper';
import { StyledStepper } from './subcomponents';
var ProgressBar = function () {
    var currentRoute = useMainContext().currentRoute;
    var i18n = useTranslation();
    var steps = [
        { label: i18n('settlement.questionnaireHeading') },
        { label: i18n('settlement.reviewHeading') },
        { label: i18n('settlement.enrollmentHeading') }
    ];
    var activeStep;
    switch (currentRoute) {
        case Routes.SETTLEMENT_QUESTIONNAIRE:
        case Routes.PLAN_QUESTIONNAIRE:
            activeStep = 0;
            break;
        case Routes.SETTLEMENT_OPTIONS:
        case Routes.SETTLEMENT_REVIEW:
        case Routes.PLAN_REVIEW:
        case Routes.PLAN_CONFIRM:
            activeStep = 1;
            break;
        case Routes.SETTLEMENT_SUCCESS:
        case Routes.PLAN_SUCCESS:
            activeStep = 3;
            break;
        default:
            activeStep = undefined;
            break;
    }
    return (_jsx(RenderIf, __assign({ condition: activeStep !== undefined }, { children: _jsx(StyledStepper, { children: _jsx(Stepper, { steps: steps, circleRadius: 5, activeStep: activeStep, completedIcon: _jsx(FontAwesomeIcon, { icon: ['far', 'check'], size: "sm" }) }) }) })));
};
export default ProgressBar;
//# sourceMappingURL=index.js.map